module.exports = __webpack_public_path__ + "img/play.5b7057a8.png";